import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';

interface RouteParams {
  resource_type_id: string;
}

export default class ResourcesResourceTypeIndexRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;

  model({ resource_type_id }: RouteParams): void {
    if (resource_type_id === '2' && this.abilities.cannot('use parking resource')) {
      void this.router.transitionTo('unauthorized');
    }
  }
}
